/* eslint-disable class-methods-use-this */

import { Component } from 'react';
import PropTypes from 'prop-types';

import { findRouteMatch } from 'route-data/find-route-match';
import { objectWithNumericKeys } from 'utils/prop-types/object-with-numeric-keys';

const isEqualLocation = (
  { pathname: pathname1, search: search1 },
  { pathname: pathname2, search: search2 },
) => pathname1 === pathname2 && search1 === search2;

export default class DataProvider extends Component {
  static propTypes = {
    // eslint-disable-next-line react/no-unused-prop-types
    clearPreloadedIfLocationChanged: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    clientFetch: objectWithNumericKeys,
    // eslint-disable-next-line react/no-unused-prop-types
    clientPageLoaded: PropTypes.func.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    clientPageLoading: PropTypes.func.isRequired,
    isPageDataPreloadInProgress: PropTypes.bool.isRequired,
    // eslint-disable-next-line react/no-unused-prop-types
    fetch: objectWithNumericKeys,
    location: PropTypes.shape({
      pathname: PropTypes.string.isRequired,
      search: PropTypes.string.isRequired,
      state: PropTypes.shape({
        refinement: PropTypes.bool,
      }),
    }).isRequired,
  };

  state = {
    key: null,
  };

  componentDidMount() {
    // eslint-disable-next-line react/destructuring-assignment
    if (!this.props.isPageDataPreloadInProgress) {
      this.fetchRouteData(this.props);
    }
  }

  componentDidUpdate(prevProps) {
    const { location: prevLocation } = prevProps;
    const { location } = this.props;

    if (!isEqualLocation(prevLocation, location)) {
      this.fetchRouteData(this.props, true);
    }
  }

  fetchRouteData(props, isClientNavigation = false) {
    const { clearPreloadedIfLocationChanged, location, clientPageLoaded, clientPageLoading } =
      props;

    clearPreloadedIfLocationChanged(location);

    const routeMatch = findRouteMatch(location.pathname);

    if (!routeMatch) {
      clientPageLoaded();

      return;
    }

    const { fetch, clientFetch, index, match } = routeMatch;

    if (!location.state?.refinement) {
      clientPageLoading();
    }

    this.setState({ key: location.key });

    const shouldFetch = isClientNavigation || !props.preloaded;

    Promise.resolve(shouldFetch && fetch ? props.fetch[index]({ location, match }) : null)
      .then(() => (clientFetch ? props.clientFetch[index]({ location, match }) : null))
      .then(() => {
        // eslint-disable-next-line react/destructuring-assignment
        if (location.key === this.state.key) {
          clientPageLoaded();
        }
      });
  }

  render() {
    return null;
  }
}
